import { render, staticRenderFns } from "./q-bank-list-page.html?vue&type=template&id=27ba493e&scoped=true&external"
import script from "./q-bank-list-page.js?vue&type=script&lang=js&external"
export * from "./q-bank-list-page.js?vue&type=script&lang=js&external"
import style0 from "./q-bank-list-page.scss?vue&type=style&index=0&id=27ba493e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba493e",
  null
  
)

export default component.exports